import { ChangeRequestBase } from './base/change-request-base';

export class ChangeRequest extends ChangeRequestBase { }